import request from '@/utils/request'


// 查询健康专区列表
export function listHealth(query) {
  return request({
    url: '/health/health/list',
    method: 'get',
    params: query
  })
}

// 查询健康专区分页
export function pageHealth(query) {
  return request({
    url: '/health/health/page',
    method: 'get',
    params: query
  })
}

// 查询健康专区详细
export function getHealth(data) {
  return request({
    url: '/health/health/detail',
    method: 'get',
    params: data
  })
}

// 新增健康专区
export function addHealth(data) {
  return request({
    url: '/health/health/add',
    method: 'post',
    data: data
  })
}

// 修改健康专区
export function updateHealth(data) {
  return request({
    url: '/health/health/edit',
    method: 'post',
    data: data
  })
}

// 删除健康专区
export function delHealth(data) {
  return request({
    url: '/health/health/delete',
    method: 'post',
    data: data
  })
}
